module.exports = __webpack_public_path__ + "fonts/Stelvio-Grotesk-Bold.586c7fd.woff";